  function formatAED(cents) {
  return 'AED ' + (cents / 100).toFixed(2);
}

document.addEventListener('DOMContentLoaded', function () {

  const box = document.getElementById('free-shipping-message');

  if (!box) return;

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => updateFreeShippingMessage(cart));

});

function updateFreeShippingMessage(cart) {

  const box = document.getElementById('free-shipping-message');
  if (!box) return;

  const threshold = parseInt(box.dataset.threshold);

  const remaining = Math.max(0, threshold - cart.total_price);

  if (remaining > 0) {

    box.innerHTML = `
      Order total is <strong>${formatAED(cart.total_price)}</strong><br>
      Add <strong>${formatAED(remaining)}</strong>
      to qualify for <strong>FREE SHIPPING</strong>.
    `;

  } else {

    box.innerHTML =
      '🎉 Your order qualifies for <strong>FREE SHIPPING</strong>.';

  }
}







$(window).on('load', function(){

  // added for cart stats
   // added for cart ends
});

$(document).ready(function(){
  // $('.toggle-menu').on("click", function(){
  //   if($(this).hasClass('open')){

  //     // var nav_li = TweenMax.staggerFromTo('.top-menu-wrapper .nav-menu > li ul li', 0.8 ,
  //     // { 
  //     //   opacity: 1,
  //     //   x: "0%",
  //     //   ease: Circ.easeInOut
  //     // },
  //     // {
  //     //   opacity: 0,
  //     //   x: "-20%",
  //     //   ease: Circ.easeInOut
  //     // },0.08 , "-=0.01", "0.01");

  //     $(this).removeClass('open');
      
  //     setTimeout(function() {
  //       $('.top-menu-wrapper').removeClass('open');
  //       $('header').removeClass('hide');
  //      }, 500);
  //   }
  //   else{

  //     $(this).addClass('open');
  //     $('.top-menu-wrapper').addClass('open');
  //     setTimeout(function() {
  //       $('header').addClass('hide');
  //      }, 10);

  //     //  var nav_li = TweenMax.staggerFromTo('.top-menu-wrapper .nav-menu > li ul li', 0.5,
  //     // { 
  //     //   opacity: 0,
  //     //   x: "-20%",
  //     //   ease: Circ.easeInOut
  //     // },
  //     // {
  //     //   opacity: 1,
  //     //   x: "0%",
  //     //   ease: Circ.easeInOut
  //     // },0.08 , "0.05");
  //   }
  // });


  $('.toggle-menu').on("click", function(){
    if($(this).hasClass('open')){
 
      $(this).removeClass('open');
      
      setTimeout(function() {
        $('.banner-vid-wrapper').removeClass('border');
        $('.top-menu-wrapper').removeClass('open');
        $('.mobile-menu-wrapper').removeClass('open');
        $('header').removeClass('hide');
       }, 500);
    }
    else{
 
      $(this).addClass('open');
      $('.banner-vid-wrapper').addClass('border');
      $('.top-menu-wrapper').addClass('open');
      $('.mobile-menu-wrapper').addClass('open');
      setTimeout(function() {
        $('header').addClass('hide');
       }, 10);
    }
  });

  $('.acc').on('click', function(){
    $('.acc-link').toggleClass('show');
  });
  $('main').click(function(){
    if($('.acc-link').hasClass('show')){
      $('.acc-link').removeClass('show')
    }
  });

  $('.tabs-nav a').click(function() {

    // Check for active
    $('.tabs-nav li').removeClass('active');
    $(this).parent().addClass('active');

    // Display active tab
    let currentTab = $(this).attr('href');
    $('.tabs-content div').hide();
    $(currentTab).show();

    return false;
    });

    $('.commer-content ul.tabs li').click(function(){
      var tab_id = $(this).attr('data-tab');

      $('.commer-content ul.tabs li').removeClass('current');
      $('.commer-content .tab-content').removeClass('current');

      $(this).addClass('current');
      $("#"+tab_id).addClass('current');
    })

});
